export default __webpack_public_path__ + "static/media/cityScape.0d754986.png";